import {useDebugValue} from 'react';

import {
    useSubmitActions,
    useSubmitEvents,
    useSubmitOptions,
    useSubmitSettings,
    useSubmitTranslations
} from './';

function useSubmit(props) {
    const {
        events
    } = useSubmitEvents(props);

    const {
        options
    } = useSubmitOptions(props);

    const {
        initialSettings,
        settings,
        changeSettings
    } = useSubmitSettings(props);

    const {
        translations
    } = useSubmitTranslations(props);

    const actions = useSubmitActions({
        events,
        options,
        initialSettings,
        settings,
        changeSettings,
        translations
    });

    const result = {
        actions,
        events,
        options,
        settings,
        translations
    };

    useDebugValue(result);

    return result;
}

export {useSubmit};
